import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/org/')({
  
  beforeLoad: () => {
    throw redirect({ to: '/admin/orgs' })
  },
})
